//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import searchInput from '@/components/search-input';
import fileUpload from '@/components/file-upload'
import SearchSearch from "../../components/search-search";
import {listSort} from "../../utils/commons";




export default {
  name: "list-received",
  components: {DivSpan,SearchSearch,searchInput,fileUpload},
  data() {
    return {
      list: [],
      searchData: [],
      stateList:[{name:'全部',code:null},
        {name:'制单中',code:'DRAFT'},
        {name:'待发货',code:'TO_BE_DELIVERED'},
        {name:'待收货',code:'TO_BE_RECEIVED'},
        {name:'已收货',code:'RECEIVED'},
        {name:'已废弃',code:'ABANDONED'},
        ],
      showMore: true,
      page: 0,
      workflowId: '',
      codeSort: 'DESC',
      customStatus: '',
    }
  },

  methods: {
    getRestState(){
      this.$get('api/config-para/search-with-list?mainCode=asnStatus').then(data=>{
        this.customStatus = data.configParaDts;
        this.customStatus=listSort(this.customStatus,'paraValue1','asc');
        this.stateList.splice(2,0,...this.customStatus);
      });
    },
    onItemClick(item){
      if(item.code ||item.typeCode){
        this.searchData['asn.status-eq'] = item.code ||item.typeCode;
      }else{
        delete this.searchData['asn.status-eq'];
      }
      this.getList();
    },
    getMore(){
      this.page++;
      this.$search('api/asn-dt', {sort:'createdDate,'+this.codeSort, page: this.page, size: 10},this.searchData).then(list => {
        this.list = this.list.concat(list);
        list.length<10?(this.showMore=false):''
      }).catch((error) => {
      });
    },
    view(id) {
      this.$router.push('/asn-view/'+id)
    },
    searchPurCode(values) {
      this.searchData['asn.orderNo']=values
      this.getList()
    },
    delPurCode(){
      delete this.searchData['asn.orderNo']
      this.getList()
    },
    searchPerson(values) {
      this.searchData['createdBy']=values.createdBy;
      this.getList()
    },
    delPerson(){
      delete this.searchData['createdBy'];
      this.getList()
    },
    searchPurchaser(values) {
      this.searchData['asn.carrier']=values.linkman;
      this.getList()
    },
    delPurchaser(){
      delete  this.searchData['asn.carrier'];
      this.getList()
    },
    getList() {
      this.$loadingShow();
      this.$search('api/asn-dt', {sort:'createdDate,'+this.codeSort,page: 0, size: 10}, this.searchData).then((data) => {
        this.list = data;
        data.length<10?this.showMore=false:''
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },

    // 跳转到 常用页面
    goGeneral() {
      if(this.$store.state.device === 'wap'){
        this.$router.go(-1);
      }else{
        document.location = "http://action:10002/?";
      }
    },

    getWorkflowId(){
      this.$get('api/biz-object-parameters/key/purRequisition').then(data=>{
        this.workflowId=data.workflowType;
        this.getList();
      })
    },
  },
  mounted() {
    this.getWorkflowId();
    this.getRestState()
  },


}



// WEBPACK FOOTER //
// ./src/page/asn/list-received.vue